// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2361":"702a36d807454f32","7967":"f50f7568730e1fb5"}[chunkId] + ".css";
};